import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 2v12h3v9l7-12H9l4-9zm14 0l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2h-2zm-.15 5.65L18 4l1.15 3.65h-2.3z"
}), 'FlashAutoTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FlashAutoTwoTone.js
// module id = 3718
// module chunks = 2